import { useTranslation } from "react-i18next"
import { UpdateAmphoraCommunications } from "schema"
import { toast } from "sonner"
import { useGmailIntegrationsQuery } from "../gmail/useGmailIntegrationsQuery"
import { useWhatsappIntegrationConfigurationQuery } from "../whatsapp/useWhatsappIntegrationConfigurationQuery"
import { useAmphoraIntegrationQuery } from "./useAmphoraIntegrationQuery"
import { useUpdateAmphoraCommunicationsMutation } from "./useUpdateAmphoraCommunicationsMutation"

const toastForCommunicationsUpdate = (
  t: (key: string) => string,
  payload: UpdateAmphoraCommunications,
) => {
  if (payload.useWhatsapp === true) {
    toast.success(t("settings.integrations.amphora.communications.toast.whatsappOn"))
    return
  }

  if (payload.useEmail === true) {
    toast.success(t("settings.integrations.amphora.communications.toast.gmailOn"))
    return
  }

  if (payload.useWhatsapp === false && payload.useEmail === undefined) {
    toast.success(t("settings.integrations.amphora.communications.toast.whatsappOff"))
    return
  }

  if (payload.useEmail === false && payload.useWhatsapp === undefined) {
    toast.success(t("settings.integrations.amphora.communications.toast.gmailOff"))
  }
}

export function useCommunicationsConfigState() {
  const { t } = useTranslation()
  const { data } = useAmphoraIntegrationQuery()
  const { data: whatsappIntegration } = useWhatsappIntegrationConfigurationQuery()
  const { data: gmailIntegrations } = useGmailIntegrationsQuery()
  const { mutate, isPending } = useUpdateAmphoraCommunicationsMutation()

  const hasOwnWhatsappIntegration = !!whatsappIntegration && !whatsappIntegration.isPermutAccount
  const whatsappDisabled = !hasOwnWhatsappIntegration
  const gmailDisabled = !gmailIntegrations?.length

  const hasWhatsappLogisticsCampaign = data?.hasWhatsappLogisticsCampaign ?? false

  const commitUpdate = (payload: UpdateAmphoraCommunications) => {
    mutate(payload, {
      onSuccess: () => toastForCommunicationsUpdate(t, payload),
    })
  }

  return {
    isPending,
    whatsappDisabled,
    gmailDisabled,
    useWhatsappEnabled: data?.useWhatsapp ?? true,
    useEmailEnabled: data?.useEmail ?? false,
    hasWhatsappLogisticsCampaign,
    commitUpdate,
  }
}
